module.exports = __webpack_public_path__ + "src/assets/textures/tractor/fuel_gauge.png";